import React from 'react';
import CommonOperationScreen from '../../components/CommonOperationScreen/CommonOperationScreen';
import { OPERATIONS } from '../../constants';

const PreCal = () => {
	return (
		<CommonOperationScreen operationName={OPERATIONS.PRE_CAL} buttonLabel="Mark PRE CAL Complete" />
	);
};

export default PreCal;
